export default {"src":"/_next/static/media/webServermaintenance.0810c5c8.svg","height":305,"width":457,"blurWidth":0,"blurHeight":0};